import labels from '../../api/labels';

export default (state = labels.logo.emptyResponse, action) => {
	switch (action.type) {
		case 'LABELS_LOGO_DATA':
			return action.data;
		default:
			return state;
	}
};

export const action = {
	data: data => ({ type: 'LABELS_LOGO_DATA', data }),
};
